class User {
  static findAttribute(user, key, defaultValue = "") {
    for (let item of user["Attributes"]) {
      if (item["Name"] === key) {
        return item["Value"];
      }
    }
    return defaultValue;
  }

  static findUserAttribute(user, key, defaultValue = "") {
    for (let item of user["UserAttributes"]) {
      if (item["Name"] === key) {
        return item["Value"];
      }
    }
    return defaultValue;
  }

  static getUserLoggedInAttribute(user, key, defaultValue = "") {
    return key in user.attributes ? user.attributes[key] : defaultValue;
  }
}

export default User;
